module.exports = __webpack_public_path__ + "static/media/empf.afd9db9a.gif";